import _ from 'lodash'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { withAppService } from 'services/app'
import { withOrganizationService } from 'services/organization'
import { withSupportedTimezonesService } from 'services/supportedTimezones'

import OrganisationsPreviewView from './OrganisationsPreviewView'

const GROUPS = {
  read: [
    'organization.numberOfNurseries',
    'organization.details',
    'organization.organizationSettings',
    'organizationSettings',
    'organizationSettings.localeDetails',
  ],
}

class OrganisationsPreviewContainer extends Component {
  constructor() {
    super()

    this.state = {
      supportedTimezones: undefined,
    }
  }

  componentDidMount() {
    const {
      organizationActions,
      params: { organisationId },
      supportedTimezonesActions,
    } = this.props

    organizationActions.get(organisationId, {
      onSuccess: () => {
        organizationActions.listFlags(organisationId)

        supportedTimezonesActions.list({
          onSuccess: ({ data }) => {
            this.setState({
              supportedTimezones: _.reduce(data, (result, item) => ({
                ...result,
                ...item,
              }), {}),
            })
          },
          onlyData: true,
        })
      },
      params: { groups: GROUPS },
    })
  }

  componentWillUnmount() {
    const { organizationActions } = this.props

    organizationActions.clearSingle()
  }

  render() {
    const { featureFlags, isFetching, organisation } = this.props
    const { supportedTimezones } = this.state

    return (
      <OrganisationsPreviewView
        featureFlags={featureFlags}
        isFetching={isFetching}
        organisation={organisation}
        supportedTimezones={supportedTimezones}
      />
    )
  }
}

const mapState = (state, {
  appSelectors,
  organizationSelectors,
  organizationSingleState,
}) => ({
  featureFlags: organizationSelectors.getOrganizationFlags(state),
  isFetching: appSelectors.getIsFetching(organizationSingleState),
  organisation: organizationSelectors.getOrganizationData(state),
})

const enhance = compose(
  withAppService,
  withOrganizationService,
  withSupportedTimezonesService,
  connect(mapState),
)

export default enhance(OrganisationsPreviewContainer)
